const BACUSEXP = 'BACUSEXP'; // BANKER ACCEPTANCES - EXPORT, CUSTOMER LIABILITIES
const BACUSIMP = 'BACUSIMP'; // BANKER ACCEPTANCES - IMPORT, CUSTOMER LIABILITIES
const BACUSPCH = 'BACUSPCH'; // BANKER ACCEPTANCES - PURCHASE/SALES, CUSTOMER LIABILITIES
const BANKACCP = 'BANKACCP'; // BANKER ACCEPTANCES - PURCHASE/SALES, CUSTOMER LIABILITIES
const BAOWNEXP = 'BAOWNEXP'; // BANKER ACCEPTANCES - EXPORT, OWN BILLS DISCOUNTED
const BAOWNIMP = 'BAOWNIMP'; // BANKER ACCEPTANCES - IMPORT,  OWN BILLS DISCOUNTED
const BAOWNPCH = 'BAOWNPCH'; // BANKER ACCEPTANCES - PURCHASE/SALES,  OWN BILLS DISCOUNTED
const BLOKDNSG = 'BLOKDNSG'; // BLOCK DISCOUNTING FOR NON-SCHEDULED GOODS BILLS DISCOUNTED
const BLOKDREC = 'BLOKDREC'; // BLOCK DISCOUNTING RECEIVABLESEDULED GOODS
const BLOKDSCG = 'BLOKDSCG'; // BLOCK DISCOUNTING FOR SCHEDULED GOODS
const BRIDGING = 'BRIDGING'; // CONSTRUCTION BRIDGING LOAN/FINANCEODS
const BRLNFNCE = 'BRLNFNCE'; // BRIDGING LOANS/FINANCINGAN/FINANCE
const CHRGCARD = 'CHRGCARD'; // CHARGE CARDANS/FINANCING
const CRDTCARD = 'CRDTCARD'; // CREDIT CARD
const DMBLPCHD = 'DMBLPCHD'; // DOMESTIC BILLS PURCHASED
const EXPCRDRE = 'EXPCRDRE'; // EXPORT CREDIT REFINANCING
const FACTORNG = 'FACTORNG'; // FACTORING RECEIVABLENCING
const FGBLPCHD = 'FGBLPCHD'; // FOREIGN BILLS PURCHASED
const FLRSTCKG = 'FLRSTCKG'; // FLOOR STOCKING LOANS/FINANCING
const FNGNTRDE = 'FNGNTRDE'; // FINANCIAL GUARANTEE - NON-TRADE
const FNGTRADE = 'FNGTRADE'; // FINANCIAL GUARANTEE - TRADERADE
const FNINSOFN = 'FNINSOFN'; // FINANCIAL INSTITUTION OWN FUND
const FWFGNECH = 'FWFGNECH'; // FORWARD FOREIGN EXCHANGEN FUND
const HLFNNNPS = 'HLFNNNPS'; // NON-PRIORITY HOUSING LOAN/FINANCE
const HLFNPRSR = 'HLFNPRSR'; // PRIORITY SECTOR HOUSING LOAN/FINANCE
const HRPCNSCG = 'HRPCNSCG'; // HIRE PURCHASE FOR NON-SCHEDULED GOODS
const HRPCSCGD = 'HRPCSCGD'; // HIRE PURCHASE FOR SCHEDULED GOODSOODS
const HSLNFNCE = 'HSLNFNCE'; // HOUSING LOANS/FINANCINGULED GOODS
const ISBENECT = 'ISBENECT'; // BENEVOLENT CREDITANCING
const ISEQYFNG = 'ISEQYFNG'; // EQUITY FINANCINGT
const ISPJTFNG = 'ISPJTFNG'; // PROJECT FINANCING
const ISPWNBKG = 'ISPWNBKG'; // PAWNBROKINGANCING
const LEASING = 'LEASING'; // LEASING RECEIVABLES
const LOANSTCK = 'LOANSTCK'; // LOAN STOCK (ARISING FROM RESTRUCTURING)
const LTCREDIT = 'LTCREDIT'; // LETTER OF CREDITING FROM RESTRUCTURING)
const MICROEFN = 'MICROEFN'; // MICRO ENTERPRISE FUND
const OHRPCREC = 'OHRPCREC'; // OTHER HIRE PURCHASE RECEIVABLES
const OPCQPCHD = 'OPCQPCHD'; // OUTPORT CHEQUE PURCHASEDIVABLES
const OTHLNFIN = 'OTHLNFIN'; // OTHER LOANS/FINANCINGSED
const OTLNFNCE = 'OTLNFNCE'; // OTHER TERM LOANS/FINANCING
const OTSHTFAC = 'OTSHTFAC'; // OTHER OFF-BALANCE SHEET FACILITIES
const OTTRDDIS = 'OTTRDDIS'; // OTHER TRADE BILLS DISCOUNTEDLITIES
const OTTRDFAC = 'OTTRDFAC'; // OTHER TRADE FACILITIESOUNTED
const OVRDRAFT = 'OVRDRAFT'; // OVERDRAFTDE FACILITIES
const PCPASCAR = 'PCPASCAR'; // PURCHASE OF PASSENGER CARS
const PELNFNCE = 'PELNFNCE'; // PERSONAL LOANS/FINANCINGRS
const PGRANTEE = 'PGRANTEE'; // PERFORMANCE GUARANTEEING
const POSHPECR = 'POSHPECR'; // POST-SHIPMENT ECRNTEE
const PRESHPCR = 'PRESHPCR'; // PRE-SHIPMENT ECRR
const RVVGCRDT = 'RVVGCRDT'; // REVOLVING CREDIT
const SBLTCRDT = 'SBLTCRDT'; // STANDBY LETTER OF CREDIT
const SHMARGIN = 'SHMARGIN'; // SHARE MARGIN FINANCINGIT
const SHPGRTEE = 'SHPGRTEE'; // SHIPPING GUARANTEECING
const STLNFNCE = 'STLNFNCE'; // STAFF LOAN/FINANCE
const TEMPOVDT = 'TEMPOVDT'; // TEMPORARY OVERDRAFT
const TFWORECO = 'TFWORECO'; // TRADE FINANCE WITHOUT RECOURSE
const TRECEIPT = 'TRECEIPT'; // TRUST RECEIPTSWITHOUT RECOURSE

export const FACILITY_CODES = [
  BACUSEXP,
  BACUSIMP,
  BACUSPCH,
  BANKACCP,
  BAOWNEXP,
  BAOWNIMP,
  BAOWNPCH,
  BLOKDNSG,
  BLOKDREC,
  BLOKDSCG,
  BRIDGING,
  BRLNFNCE,
  CHRGCARD,
  CRDTCARD,
  DMBLPCHD,
  EXPCRDRE,
  FACTORNG,
  FGBLPCHD,
  FLRSTCKG,
  FNGNTRDE,
  FNGTRADE,
  FNINSOFN,
  FWFGNECH,
  HLFNNNPS,
  HLFNPRSR,
  HRPCNSCG,
  HRPCSCGD,
  HSLNFNCE,
  ISBENECT,
  ISEQYFNG,
  ISPJTFNG,
  ISPWNBKG,
  LEASING,
  LOANSTCK,
  LTCREDIT,
  MICROEFN,
  OHRPCREC,
  OPCQPCHD,
  OTHLNFIN,
  OTLNFNCE,
  OTSHTFAC,
  OTTRDDIS,
  OTTRDFAC,
  OVRDRAFT,
  PCPASCAR,
  PELNFNCE,
  PGRANTEE,
  POSHPECR,
  PRESHPCR,
  RVVGCRDT,
  SBLTCRDT,
  SHMARGIN,
  SHPGRTEE,
  STLNFNCE,
  TEMPOVDT,
  TFWORECO,
  TRECEIPT,
];

export const isFacilityCodeVehicle = code => [
  HRPCNSCG,
  HRPCSCGD,
  PCPASCAR,
  OHRPCREC,
].some(c => c === code);

export const isFacilityCodeCreditCard = code => [
  CHRGCARD,
  CRDTCARD,
].some(c => c === code);

export const isFacilityCodeHouse = code => [
  HLFNNNPS,
  HLFNPRSR,
  HSLNFNCE,
].some(c => c === code);

export const isFacilityCodePersonal = code => code === PELNFNCE;

export const isFacilityCodeSpecialOther = code => code === OTLNFNCE;

export const isFacilityCodeOther = code => !isFacilityCodeVehicle(code) &&
  !isFacilityCodeCreditCard(code) &&
  !isFacilityCodeHouse(code) &&
  !isFacilityCodePersonal(code);



// WEBPACK FOOTER //
// ./src/constants/facilityCodes.js